/**
 * @description gets the filename from a url
 * @param url
 * @returns the name and extension of the file
 */
export const getUrlFilename = (url) => {
    let filename = undefined;
    let extension = undefined;
    if (url) {
        const parts = url.split(/[#?]/);
        if (parts.length > 0) {
            filename = parts[0].split('/').pop();
            if (filename)
                extension = filename.split('.').pop();
        }
    }
    return { filename, extension };
};
export function getGoogleMapQueryLink(parts) {
    let query;
    if (typeof parts === 'string') {
        query = parts;
    }
    else if ('lat' in parts) {
        query = `${parts.lat},${parts.long}`;
    }
    else if ('addressLine1' in parts) {
        const region = [parts.city, parts.countyOrParishCode, parts.stateOrProvince]
            .filter((part) => !!part)
            .join(', ');
        const order = [parts.addressLine1, parts.addressLine2, region, parts.zipOrPostalCode].filter((part) => !!part);
        query = order.join(' ');
    }
    else if ('street1' in parts) {
        const region = [parts.city, parts.county, parts.state].filter((part) => !!part).join(', ');
        const order = [parts.street1, parts.street2, region, parts.zipcode].filter((part) => !!part);
        query = order.join(' ');
    }
    else {
        throw new Error('invalid argument for getGoogleMapQueryLink');
    }
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}
